/**
The main entry point for a Fabric.

Referenced by the page.fabric.liquid template.
* */
import ReactDOM from 'react-dom';
import Fabric from './components/Fabric';
import OVApp from './utils/OVContext';
import './scss/templates/page-fabric.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  var search = window.location.search; // eslint-disable-line

  var urlParams = new URLSearchParams(search);
  var id = urlParams.get('fabric');
  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(Fabric, {
      id: id
    })
  }), document.getElementById('fabric'));
};

init();